// =====================================
//
//   企業用戶 landing page controller
//   Author: Gray
//   createtime: 2017 / 06 / 26
//   updatetime: 2017 / 06 / 26
//
// =====================================
window.InifECMobileApp.controller("EnterpriseSignupController", ['$scope', '$state', '$timeout', '$rootScope', '$stateParams', 'BusinessMemberService', '$PreviousState',
    function($scope, $state, $timeout, $rootScope, $stateParams, BusinessMemberService, $PreviousState) {

        // --------------------------------
        // 切換為介紹／註冊畫面
        // --------------------------------
        var changeInvitation = function(isInvitation) {

            if(isInvitation) {
                $scope.step = 'invitation';
            } else {
                $scope.step = undefined;
            }

            document.body.scrollTop = document.documentElement.scrollTop = 0;
        }

        // --------------------------------
        // 提出申請企業會員
        // --------------------------------
        var applyBusinessMember = function() {
var isParamsError; // bundler：原本是隱式全域（沒有 var），strict mode 會 ReferenceError

            if($scope.isLoading) {
                return;
            }

            var isParamError = false;

            $scope.isBusinessmrscidError = false;
            $scope.isNameEmpty = false;
            $scope.isPasswdEmpty = false;
            $scope.isRepasswdEmpty = false;
            $scope.isConfirmPasswordError = false;
            $scope.isEmailEmpty = false;
            $scope.isEmailError = false;
            $scope.isMobilePhoneEmpty = false;
            $scope.isMobilePhoneError = false;
            $scope.isPhoneEmpty = false;
            $scope.isPhoneError = false;
            $scope.isCompanyEmpty = false;
            $scope.isInvoiceEmpty = false;
            $scope.isInvoiceError = false;
            $scope.isAddressEmpty = false;
            $scope.isPostalEmpty = false;
            $scope.isPostalError = false;
            $scope.isSuccess = false;
            $scope.errorMsg = "";

            if(!$scope.form.businessmrscid) {
                $scope.isBusinessmrscidError = true;
                isParamError = true;
            }

            if(!$scope.form.name) {
                $scope.isNameEmpty = true;
                isParamError = true;
            }

            if(!$scope.form.passwd) {
                $scope.isPasswdEmpty = true;
                isParamError = true;
            }

            if(!$scope.form.repasswd) {
                $scope.isRepasswdEmpty = true;
                isParamError = true;
            }

            if($scope.form.password != $scope.form.repassword) {
                $scope.isConfirmPasswordError = true;
                isParamsError = true;
            }

            if(!$scope.form.email){
                $scope.isEmailEmpty = true;
                isParamError = true;
            } else if(!isEmail($scope.form.email)) {
                $scope.isEmailError = true;
                isParamError = true;
            }

            if(!$scope.form.mobilephone) {
                $scope.isMobilePhoneEmpty = true;
                isParamError = true;
            } else if(!isPhone($scope.form.mobilephone)) {
                $scope.isMobilePhoneError = true;
                isParamError = true;
            }

            if(!$scope.form.phone) {
                $scope.isPhoneEmpty = true;
                isParamError = true;
            } else if(!isPhone($scope.form.phone)) {
                $scope.isPhoneError = true;
                isParamError = true;
            }

            if(!$scope.form.company) {
                $scope.isCompanyEmpty = true;
                isParamError = true;
            }

            if(!$scope.form.invoice) {
                $scope.isInvoiceEmpty = true;
                isParamError = true;
            } else if(!isTaxIDNumber($scope.form.invoice)) {
                $scope.isInvoiceError = true;
                isParamError = true;
            }

            if(!$scope.form.postal) {
                $scope.isPostalEmpty = true;
                isParamError = true;
            } else if($scope.form.postal && isNaN($scope.form.postal)) {
                $scope.isPostalError = true;
                isParamError = true;
            }

            if(isParamError) {
                return
            }

            var businessmrscid = $scope.form.businessmrscid,
                passwd = $scope.form.passwd,
                email = $scope.form.email,
                mobilephone = $scope.form.mobilephone,
                name = $scope.form.name,
                company = $scope.form.company,
                invoice = $scope.form.invoice,
                phone = $scope.form.phone,
                phoneExtension = $scope.form.phoneExtension,
                address = $scope.form.address,
                postal = $scope.form.postal;

            $scope.isLoading = true;

            BusinessMemberService.register(businessmrscid, passwd, email, mobilephone, name, company, invoice, phone, phoneExtension, address, postal).then(function(result) {

                if(result) {
                    $scope.isSuccess = true;
                    $rootScope.$broadcast("OPEN_EMAIL_MESSAGE_MODAL", {
                        callback: function() {
                            $state.go(window.STATES.HOME);
                        }
                    });
                } else {
                    $scope.errorMsg = "系統發生無法預期的錯誤，請重新再試或是聯繫客服人員。";
                }

                $scope.isLoading = false;
            }, function(error) {

                if(error && error.code == "error.account.accountRepeat") {
                    $scope.errorMsg = "該帳戶已經是企業用戶囉。";
                } else if(error && error.code == "error.apply.applicationReviewing") {
                    $scope.errorMsg = "該帳戶申請企業會員還在審查中，請耐心等候。";
                } else if(error && error.code == "error.account.emailRepeat") {
                    $scope.errorMsg = "電子信箱已被人使用了。";
                } else if(error && error.code == "error.account.mobilephoneRepeat") {
                    $scope.errorMsg = "行動電話已被人使用了。";
                } else if(error && error.code == "error.apply.applicationSuccess") {
                    $scope.errorMsg = "您已經是會員囉，請直接登入。";
                } else if(error && error.code == "error.apply.alreadyApproved") {
                    $scope.errorMsg = "已經將會員認證信寄送至您的電子郵件。";
                } else {
                    $scope.errorMsg = "系統發生無法預期的錯誤，請重新再試或是聯繫客服人員。";
                }

                $scope.isLoading = false;
            })
        }

        // --------------------------------
        // [private] 重置變數
        // --------------------------------
        var reset = function() {

            $scope.form.businessmrscid = '';
            $scope.form.name = '';
            $scope.form.passwd = '';
            $scope.form.repasswd = '';
            $scope.form.email = '';
            $scope.form.mobilephone = '';
            $scope.form.phone = '';
            $scope.form.phoneExtension = '';
            $scope.form.company = '';
            $scope.form.invoice = '';
            $scope.form.city = '';
            $scope.form.dist = '';
            $scope.form.postal = '';
            $scope.form.address = '';
            $scope.form.newAddress = '';

            $scope.isBusinessmrscidError = false;
            $scope.isNameEmpty = false;
            $scope.isPasswdEmpty = false;
            $scope.isRepasswdEmpty = false;
            $scope.isConfirmPasswordError = false;
            $scope.isEmailEmpty = false;
            $scope.isEmailError = false;
            $scope.isMobilePhoneEmpty = false;
            $scope.isMobilePhoneError = false;
            $scope.isPhoneEmpty = false;
            $scope.isPhoneError = false;
            $scope.isCompanyEmpty = false;
            $scope.isInvoiceEmpty = false;
            $scope.isInvoiceError = false;
            $scope.isAddressEmpty = false;
            $scope.isPostalEmpty = false;
            $scope.isPostalError = false;
            $scope.isSuccess = false;
        }

        // --------------------------------
        // 上一頁
        // --------------------------------
        var goBack = function() {

            if($scope.step == 'invitation') {
                changeInvitation(false);
                return;
            }

            var backState = $PreviousState.getEnterpriseSignupPrevious();

            $PreviousState.goBack(backState);
        }

        // --------------------------------
        // [private] 初始化
        // --------------------------------
        var init = function() {
            
        }

        //==========================
        //  Events
        //==========================
        $scope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {

        });

        //==========================
        //  Members
        //==========================
        $scope.form = {
            businessmrscid: '',
            name: '',
            passwd: '',
            repasswd: '',
            email: '',
            mobilephone: '',
            phone: '',
            phoneExtension: '',
            company: '',
            invoice: '',
            city: '',
            dist: '',
            postal: '',
            address: '',
            newAddress: '',
        };

        $scope.step;
        $scope.isBusinessmrscidError = false;
        $scope.isNameEmpty = false;
        $scope.isPasswdEmpty = false;
        $scope.isRepasswdEmpty = false;
        $scope.isConfirmPasswordError = false;
        $scope.isEmailEmpty = false;
        $scope.isEmailError = false;
        $scope.isMobilePhoneEmpty = false;
        $scope.isMobilePhoneError = false;
        $scope.isPhoneEmpty = false;
        $scope.isPhoneError = false;
        $scope.isCompanyEmpty = false;
        $scope.isInvoiceEmpty = false;
        $scope.isInvoiceError = false;
        $scope.isAddressEmpty = false;
        $scope.isPostalEmpty = false;
        $scope.isPostalError = false;
        $scope.isSuccess = false;
        $scope.errorMsg = "";

        //==========================
        //  Methods
        //==========================
        $scope.changeInvitation = changeInvitation; // 切換為介紹／註冊畫面
        $scope.applyBusinessMember = applyBusinessMember; // 提出申請企業會員
        $scope.goBack = goBack; // 上一頁

        //==========================
        //  Init
        //==========================
        init();
    }
]);